import axios from 'axios';
import { IUserV2 } from '../../types';

interface IParams {
  rgfid: string;
  id?: string;
  // fid: string;
  context: {
    apiUrl: string;
    user?: IUserV2;
  };
}

/**
 * Download pdf populated with RootGizmoData
 *
 * @param {string} rgfid RootGizmo Flowy id
 * @param {string} id RootGizmoData database id
 * @returns
 */
function getRootGizmoDataPdf({ rgfid, id, context }: IParams): Promise<any> {
  return new Promise<any>(async resolve => {
    const { apiUrl, user } = context;

    if (user?.credentials && id) {
      const credentials: any = user.credentials;
      const url = `${apiUrl}/v3/forms/${rgfid}/filled_forms_print/${id}`;
      try {
        const response = await axios({
          url,
          method: 'GET',
          data: {},
          responseType: 'blob',
          headers: {
            ...credentials,
          },
        });

        if (response.status === 200) {
          return resolve({
            data: response.data,
          });
        }
      } catch (e) {
        // console.log('-------getRootGizmoDataPdf->e: ', e);
      }
    }

    resolve(undefined);
  });
}

export default getRootGizmoDataPdf;
